import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../../services/auth.service';
import { Enums } from '../../shared/enums';
import { Utils } from '../../shared/utils';
import { ErrorService } from '../../services/error.service';

export const authGuard: CanActivateFn = async (route, state) => {
    const authService = inject(AuthService);
    const errorService = inject(ErrorService);
    const toastr = inject(ToastrService);

    const routeData: any = route.data;

    try {
        const response = await authService.getStatus();

        if (!response.isSuccess || !response.data.isAuthenticated) {
            authService.login();
            return false;
        }

        if (!authService.$user()) {
            await authService.getUserProfile(true);
        }

        if (
            route.queryParams.usuario != null
            && Utils.isNotNullOrEmpty(authService.$user().cpf)
            && route.queryParams.usuario != authService.$user().cpf
        ) {
            const redirect = window.location.href.split('?')[0];
            await authService.logout(true);
            window.location.replace(redirect);
        }

        if (routeData && routeData.profiles && routeData.profiles.length > 0) {
            const isAllowed = authService.hasProfiles(routeData.profiles);
            if (isAllowed) {
                return true;
            } else {
                if (routeData.profiles.includes(Enums.Profiles.ErrorPage)) {
                    return true;
                }

                toastr.error(Enums.Messages.NoAccessToResource, Enums.Messages.AccessDenied, Utils.getToastrErrorOptions());
                return false;
            }
        }

        return true;
    } catch (error) {
        try {
            errorService.log({
                url: error.url,
                user: authService.$user() || null,
                error: error,
            });
        } catch { }
        authService.login();
        return false;
    }
};
